// In-world player UI strings (Map, briefing, inspect card, phone controls, VR panel, scope HUD).
// Every key is 'player.*'; the en value is the text the code used before i18n.
import { register } from '../i18n.js';

register({
  en: {
    // @@EN briefing
    'player.brief.mouseAria': 'Mouse: left button inspects, right button opens the Map, wheel zooms, moving looks around',
    'player.brief.phoneAria': 'Phone screen: the stick walks, a tap on the centre inspects, the slider or a pinch zooms, the minimap opens the Map, the lock holds the view',
    'player.brief.ctrlsAria': 'The two controllers: stick, two buttons, trigger, grip',
    'player.brief.svgInspect': 'INSPECT',
    'player.brief.svgMap': 'MAP',
    'player.brief.svgZoom': 'ZOOM',
    'player.brief.svgLook': 'LOOK',
    'player.brief.svgMonocular': 'the monocular',
    'player.brief.svgMap2d': '2D Map',
    'player.brief.svgInOut': 'in · out',
    'player.brief.svgMoveMouse': 'move the mouse',
    'player.brief.svgHold': 'HOLD',
    'player.brief.svgTap': 'TAP',
    'player.brief.svgWalk': 'WALK',
    'player.brief.svgTheView': 'the view',
    'player.brief.svgTapIt': 'tap it',
    'player.brief.svgInspectLow': 'inspect',
    'player.brief.svgOrPinch': 'or pinch',
    'player.brief.svgTheStick': 'the stick',
    'player.brief.svgLeft': 'LEFT',
    'player.brief.svgRight': 'RIGHT',
    'player.brief.actTap': 'Tap',
    'player.brief.actVr': 'Point + trigger on',
    'player.brief.actClick': 'Click',
    'player.brief.othersTitle': 'Others are here',
    'player.brief.othersSub': 'their names on their avatars',
    'player.brief.othersVoice': 'you hear them nearby',
    'player.brief.othersNoVoice': '🎤 voice on the start page',
    'player.brief.leadPre': 'The <b>Map</b> of the world. <b>{act}</b> a spot → its card → <b>⤳ Beam</b> starts you there in 3D.',
    'player.brief.leadIn': '<b>{act}</b> a spot → its card: <b>👁 Look</b> turns you to it, <b>⤳ Beam</b> takes you there.',
    'player.brief.drag': 'Drag',
    'player.brief.dragSub': 'moves the Map',
    'player.brief.pinch': 'Pinch',
    'player.brief.zoomOrPm': 'zoom · or + −',
    'player.brief.tapSpot': 'Tap a spot',
    'player.brief.cardSub': 'its card: trails, places, heights',
    'player.brief.beamPre': 'start there in 3D',
    'player.brief.beamGo': 'go there',
    'player.brief.tapRed': 'Tap a red spot',
    'player.brief.redPre': 'start there in 3D at once',
    'player.brief.redGo': 'beam there at once',
    'player.brief.chipsSub': 'MTB · amenities',
    'player.brief.players': 'Players',
    'player.brief.playersDots': 'coloured dots with names',
    'player.brief.playersTap': 'tap one: your minimap points the way',
    'player.brief.playersClick': 'click one: your minimap points the way',
    'player.brief.back3d': 'back to 3D',
    'player.brief.vrPoint': 'Point + trigger',
    'player.brief.vrPointSub': 'the controller is the pointer',
    'player.brief.vrHold': 'Hold the trigger + move',
    'player.brief.zoom': 'zoom',
    'player.brief.vrTrigSpot': 'Trigger a spot',
    'player.brief.beamVrPre': 'into the headset, there',
    'player.brief.vrRed': 'Point + trigger on a red spot',
    'player.brief.redVrPre': 'into the headset, there — at once',
    'player.brief.wheel': 'Wheel',
    'player.brief.clickSpot': 'Click a spot',
    'player.brief.clickRed': 'Click a red spot',
    'player.brief.inHeadset': 'In the headset',
    'player.brief.theMap': 'The Map',
    'player.brief.inWorld': 'In the world',
    'player.brief.pointPhone': 'Point the phone',
    'player.brief.pointPhoneSub': 'to look around · or drag',
    'player.brief.tapCentre': 'Tap the centre',
    'player.brief.tapCentreSub': 'what is there · boards at a station sign',
    'player.brief.pinchSlider': 'Pinch · slider',
    'player.brief.pinchSliderSub': 'zoom · double-tap the slider: 1×',
    'player.brief.tipFlat': 'Tip the phone flat',
    'player.brief.tipFlatSub': 'the Map · raise it: back',
    'player.brief.jump': 'JUMP',
    'player.brief.jumpSub': 'the button, bottom right',
    'player.brief.jet': 'Jet-suit',
    'player.brief.jetSub': 'ignites in the air · flies where you look',
    'player.brief.gpsSub': 'you walk where you really walk',
    'player.brief.clickView': 'Click the view',
    'player.brief.clickViewSub': 'the mouse steers the look',
    'player.brief.escSub': 'frees the mouse again',
    'player.brief.keyMove': 'move',
    'player.brief.keySprint': 'sprint',
    'player.brief.keyJump': 'jump',
    'player.brief.keyClimb': 'climb (hold)',
    'player.brief.keyBike': 'bike',
    'player.brief.keyMap': 'Map',
    'player.brief.keySign': 'station sign',
    'player.brief.keyMic': 'mic on/off',
    'player.brief.keyHelp': 'this help',
    'player.brief.jetDesk': 'ignites in the air · flies where you look · {s} brakes',
    'player.brief.bikeSub': '{w}{s} go / brake · {a}{d} steer · {q} auto-follow',
    'player.brief.lifts': 'Ride the lifts',
    'player.brief.liftsDesk': 'at a station: aim at a sign row, click (or F / G)',
    'player.brief.liftsVr': 'at a station: A / B, or point + trigger on a sign row',
    'player.brief.handLeft': 'Left hand',
    'player.brief.handRight': 'Right hand',
    'player.brief.cStick': 'stick',
    'player.brief.cStickClick': 'stick click',
    'player.brief.cStickUD': 'stick ↑ ↓',
    'player.brief.cStickLR': 'stick ← →',
    'player.brief.cTrigger': 'trigger',
    'player.brief.cGrip': 'grip',
    'player.brief.lStick': 'walk where you look: ↑↓ forward / back · ←→ sideways (full = run) — jet-suit: ↑ dive · ↓ climb · ←→ steer',
    'player.brief.lStickClick': 'the Map — open / close',
    'player.brief.lX': 'bike on / off',
    'player.brief.lYMic': 'mic on / off',
    'player.brief.lY': 'bike: auto ⇄ manual',
    'player.brief.lTrigger': 'the Map — open / close · click a panel',
    'player.brief.lGrip': 'climb — grab the rock',
    'player.brief.rStickUD': 'zoom in / out (a window in front of you, with labels) — not in flight',
    'player.brief.rStickLR': 'turn: smooth, or snap 30° / 45° (☰ → Comfort) — not in flight',
    'player.brief.rStickClick': 'jump — starts the jet-suit',
    'player.brief.rA': 'the ☰ menu — open / close (anywhere)',
    'player.brief.rB': 'close the card / panel · station sign: 2nd action (1st: point + trigger)',
    'player.brief.rTrigger': 'what is there — the card of the spot the laser points at (⤳ Beam to there) · a station sign row · click a panel',
    'player.brief.rGrip': 'climb',
    'player.brief.tFinger': 'Finger on the trigger',
    'player.brief.tFingerSub': 'right hand: the laser + a dot on what you point at · pull = its card',
    'player.brief.tHudSub': 'compass above · height, slope, ground, zoom below (☰ → HUD on / off)',
    'player.brief.tWrist': 'Left wrist — turn it to look',
    'player.brief.tWristMap': 'the map (point + trigger = the Map panel)',
    'player.brief.tMenu': 'A — ☰ menu',
    'player.brief.tMenuSub': 'Map · Help · Recenter · Comfort · HUD · Exit VR',
    'player.brief.tMapPanel': 'Map panel',
    'player.brief.tMapPanelSub': 'trigger on a spot = mark · again on the mark / ⤳ Beam here = beam · drag = pan',
    'player.brief.tMapRed': 'Map panel: a red spot',
    'player.brief.tMapRedSub': 'point + trigger on it = beam there at once',
    'player.brief.vrEnd': 'Ending the VR session brings you back to this Map.',
    'player.brief.devPhone': 'phone',
    'player.brief.devDesktop': 'desktop',
    'player.brief.againBar': '? (top bar) shows this again',
    'player.brief.againFlat': '? (top left) or the ? key shows this again',
    'player.brief.againMobile': '? (top left, under 🔒) shows this again',
    'player.brief.gpsBeam': '📍 Beam to my position',
    // @@EN playermap
    'player.map.hintFlat': 'drag to pan · wheel to zoom · click a spot to beam there',
    'player.map.hintMobile': 'pinch to zoom · tap a spot to beam there',
    'player.map.hintVr': 'point + trigger on a spot to beam there',
    'player.map.verbFlat': 'Click',
    'player.map.verbMobile': 'Tap',
    'player.map.verbVr': 'Point + trigger on',
    'player.map.closeFlat': 'Close (RMB / N / Esc)',
    'player.map.closeMobile': 'Close',
    'player.map.closeVr': 'Close (point + trigger)',
    'player.map.headingUp': 'Heading-up — tap for north-up',
    'player.map.northUp': 'North-up — tap for heading-up',
    'player.map.leave': 'Leave the Map',
    'player.map.dirN': 'N',
    'player.map.dirNE': 'NE',
    'player.map.dirE': 'E',
    'player.map.dirSE': 'SE',
    'player.map.dirS': 'S',
    'player.map.dirSW': 'SW',
    'player.map.dirW': 'W',
    'player.map.dirNW': 'NW',
    'player.map.loading': 'Loading map… {hint}',
    'player.map.combat': 'Combat is on — the map shows only you',
    'player.map.following': 'Following {name} — their beam is brighter. {verb} them again to stop.',
    'player.map.others1': '1 other player in the world — {verb} one to follow',
    'player.map.othersN': '{n} other players in the world — {verb} one to follow',
    'player.map.details': '{verb} anything on the map for details',
    // @@EN station
    'player.station.gondola': 'gondola',
    'player.station.cableCar': 'cable car',
    'player.station.chairlift': 'chairlift',
    'player.station.train': 'train',
    'player.station.departsIn': 'departs in {cd} s',
    'player.station.riding': 'riding…',
    'player.station.exit': '◎ Exit {w}',
    'player.station.waitCabin': 'Board {w} to {dest} — next cabin coming…',
    'player.station.waitChair': 'Sit on {w} to {dest} — next chair coming…',
    'player.station.waitTrain': 'Board {w} to {dest} — {w} not here yet, wait…',
    'player.station.sitOn': '◎ Sit on {w} to {dest}',
    'player.station.sitOnDep': '◎ Sit on {w} to {dest} · departs {cd}s',
    'player.station.board': '◎ Board {w} to {dest}',
    'player.station.boardDep': '◎ Board {w} to {dest} · departs {cd}s',
    'player.station.aim': 'aim & shoot to select',
    // @@EN misc
    'player.station.funicular': 'Funicular',
    'player.beacon.player': 'player-{id}',
    // @@EN mobile
    'player.mob.fire': 'FIRE',
    'player.mob.jump': 'JUMP',
    'player.mob.inspect': 'Inspect',
    'player.mob.gpsLabel': 'GPS',
    'player.mob.close': 'Close',
    'player.mob.retry': 'Try again',
    'player.mob.rotate.title': 'Turn your phone sideways',
    'player.mob.rotate.body': 'GEO-VR plays in landscape — the stick, the buttons and the view need the width.',
    'player.mob.rotate.portrait': 'Play in portrait anyway',
    'player.mob.lockView': 'Lock view',
    'player.mob.unlockView': 'Unlock view',
    'player.mob.closeMap': 'Close map',
    'player.mob.map': 'Map',
    'player.mob.gps.unavailable': 'GPS is unavailable',
    'player.mob.gps.noteBlocked': 'Leave fullscreen first — these steps start at the address bar, which is hidden here.',
    'player.mob.gps.notePolicy': 'Nothing on this phone can change this one — the server must send a different header.',
    // @@EN layers
    'player.layers.net.international': 'international',
    'player.layers.net.national': 'national',
    'player.layers.net.regional': 'regional',
    'player.layers.net.local': 'local',
    'player.layers.amenity.saddle': 'Saddle',
    'player.layers.amenity.cross': 'Cross',
    'player.layers.amenity.drinking_water': 'Drinking water',
    'player.layers.amenity.spring': 'Spring',
    'player.layers.amenity.toilets': 'Toilets',
    'player.layers.amenity.firepit': 'Fire pit',
    'player.layers.amenity.bbq': 'Barbecue',
    'player.layers.amenity.picnic_table': 'Picnic table',
    'player.layers.amenity.shelter': 'Shelter',
    'player.layers.amenity.bench': 'Bench',
    'player.layers.amenity.waste_basket': 'Waste basket',
    'player.layers.amenity.board': 'Information board',
    'player.layers.amenity.map': 'Map board',
    'player.layers.amenity.route_marker': 'Route marker',
    'player.layers.amenity.historic': 'Historic site',
    'player.layers.amenity.artwork': 'Artwork',
    'player.layers.amenity.charging_station': 'Charging station',
    'player.layers.amenity.parking': 'Parking',
    'player.layers.amenity.bicycle_parking': 'Bicycle parking',
    'player.layers.amenity.playground': 'Playground',
    'player.layers.amenity.survey_point': 'Survey point',
    'player.layers.amenity.bus_stop': 'Bus stop',
    'player.layers.amenity.summitCross': 'Summit cross',
    'player.layers.street.gate': 'Gate',
    'player.layers.street.swing_gate': 'Swing gate',
    'player.layers.street.kissing_gate': 'Kissing gate',
    'player.layers.street.stile': 'Stile',
    'player.layers.street.lift_gate': 'Lift gate',
    'player.layers.street.bollard': 'Bollard',
    'player.layers.street.barrier': 'Road barrier',
    // @@EN vrui
    'player.vr.menu.title': 'Menu',
    'player.vr.menu.map': '🗺  Map — point + trigger to beam',
    'player.vr.menu.help': '?  Help',
    'player.vr.menu.recenter': '⟲  Recenter',
    'player.vr.ctrlAsleep': 'Controllers asleep: press any controller button',
    'player.vr.menu.comfort': 'Comfort — right stick turn',
    'player.vr.menu.smooth': 'Smooth',
    'player.vr.menu.snap': 'Snap',
    'player.vr.menu.hudOn': 'HUD on — compass · status (tap: off)',
    'player.vr.menu.hudOff': 'HUD off (tap: on)',
    'player.vr.menu.picture': 'Picture (Quest)',
    'player.vr.menu.qp.current': '4× AA (before)',
    'player.vr.menu.qp.balanced': '2× AA',
    'player.vr.menu.qp.steady': 'Steady 72',
    'player.vr.status.qp.current': 'Picture: 4× AA, as before (half rate in heavy views)',
    'player.vr.status.qp.balanced': 'Picture: balanced (2× AA, lighter ground)',
    'player.vr.status.qp.steady': 'Picture: steady frame rate (no AA, lighter ground)',
    'player.vr.menu.beam': 'Beam-in — the landing',
    'player.vr.menu.beamFly': 'Fly down',
    'player.vr.menu.beamInstant': 'Instant',
    'player.vr.menu.exit': '⏏  Exit VR — back to the Map page',
    'player.vr.menu.back': '‹ Menu',
    'player.vr.help.title': 'Controls — VR controllers',
    'player.vr.help.left': 'Left controller',
    'player.vr.help.right': 'Right controller',
    'player.vr.help.bike': 'Bike · jet-suit',
    'player.vr.help.pointing': 'Pointing',
    'player.vr.help.k.stick': 'stick',
    'player.vr.help.k.stickClick': 'stick click',
    'player.vr.help.k.grip': 'grip',
    'player.vr.help.k.trigger': 'trigger',
    'player.vr.help.k.stickUD': 'stick ↑↓',
    'player.vr.help.k.stickLR': 'stick ←→',
    'player.vr.help.k.leftStick': 'left stick',
    'player.vr.help.k.jetsuit': 'jet-suit',
    'player.vr.help.k.finger': 'finger on trigger',
    'player.vr.help.k.wrist': 'left wrist',
    'player.vr.help.k.map': 'Map',
    'player.vr.help.k.mapRed': 'Map · red spot',
    'player.vr.help.walk': 'walk where you look: ↑↓ forward / back, ←→ sideways (full push = run)',
    'player.vr.help.mapToggle': 'the Map — open / close',
    'player.vr.help.bikeOnOff': 'get on / off the bike',
    'player.vr.help.mic': 'mic on / off (voice on) · on the bike: auto-follow ⇄ manual',
    'player.vr.help.climbRock': 'grab rock or a wall to climb',
    'player.vr.help.trigger': 'the data at the point: the card of what the laser points at (⤳ Beam to there) · click a panel',
    'player.vr.help.triggerMap': 'the Map — open / close · click a panel',
    'player.vr.help.zoom': 'zoom in / out — a window in front of you (back to 1× hides it)',
    'player.vr.help.turn': 'turn — smooth or snap (☰ → Comfort)',
    'player.vr.help.jump': 'jump — starts the jet-suit (then the left stick flies)',
    'player.vr.help.menuA': 'this menu — open / close · a station sign\'s rows: point + trigger',
    'player.vr.help.closeB': 'close the card / panel · at a station: the second action',
    'player.vr.help.climb': 'grab to climb',
    'player.vr.help.throttle': 'throttle ↑↓ · steer ←→ (auto-follow: flick = indicator)',
    'player.vr.help.jetsuit': 'L-stick back = climb · forward = dive · ←→ steers · speed automatic',
    'player.vr.help.laser': 'the right laser + its dot on what you point at',
    'player.vr.help.wrist': 'turn it to look: the map',
    'player.vr.help.mapMark': 'pull on a spot = mark it · pull again / ⤳ Beam here = beam',
    'player.vr.help.mapRed': 'pull on it = beam there at once (combat off)',
    'player.vr.status.recentred': 'recentred — forward is where you look',
    'player.vr.status.beamNext': 'from the next beam-in on',
    'player.vr.status.noRecenter': 'recenter is not available here',
    'player.vr.status.outside': 'outside the map',
    'player.vr.status.combatNoBeam': 'combat is on — no beaming',
    'player.vr.status.beaming': '⤳ beaming…',
    'player.vr.status.refused': 'refused — combat on, out of bounds, or another beam within 2 s',
    'player.vr.status.noReply': 'refused — no reply from the server',
    'player.vr.map.combat': 'Combat is on — the map shows only you; no beaming',
    'player.vr.map.markAgain': 'Pull again on the mark, or ⤳ Beam here — drag to pan',
    'player.vr.map.spots': 'Trigger: a red spot = beam there · any other spot = mark it — drag to pan',
    'player.vr.map.point': 'Point + trigger on a spot to mark it — drag to pan',
    'player.vr.map.clear': 'Clear',
    'player.vr.map.beamHere': '⤳ Beam here',
    'player.vr.map.asl': '{m} m a.s.l.',
    // @@EN scope
    'player.scope.n': 'N',
    'player.scope.ne': 'NE',
    'player.scope.e': 'E',
    'player.scope.se': 'SE',
    'player.scope.s': 'S',
    'player.scope.sw': 'SW',
    'player.scope.w': 'W',
    'player.scope.nw': 'NW',
    'player.scope.mag': 'MAG {zoom}×',
    'player.scope.lrf': 'LRF',
    // @@EN inspect
    'player.insp.dir.n': 'N',
    'player.insp.dir.ne': 'NE',
    'player.insp.dir.e': 'E',
    'player.insp.dir.se': 'SE',
    'player.insp.dir.s': 'S',
    'player.insp.dir.sw': 'SW',
    'player.insp.dir.w': 'W',
    'player.insp.dir.nw': 'NW',
    'player.insp.gwrCat.1010': 'temporary shelter',
    'player.insp.gwrCat.1020': 'residential only',
    'player.insp.gwrCat.1030': 'residential, other use too',
    'player.insp.gwrCat.1040': 'partly residential',
    'player.insp.gwrCat.1060': 'non-residential',
    'player.insp.gwrCat.1080': 'special structure',
    'player.insp.gwrCls.1110': 'single-dwelling house',
    'player.insp.gwrCls.1121': 'two-dwelling house',
    'player.insp.gwrCls.1122': 'apartment building',
    'player.insp.gwrCls.1130': 'communal residence',
    'player.insp.gwrCls.1211': 'hotel',
    'player.insp.gwrCls.1212': 'short-stay lodging',
    'player.insp.gwrCls.1220': 'office building',
    'player.insp.gwrCls.1230': 'shop / retail',
    'player.insp.gwrCls.1231': 'restaurant / bar',
    'player.insp.gwrCls.1241': 'transport building (station, terminal)',
    'player.insp.gwrCls.1242': 'garage',
    'player.insp.gwrCls.1251': 'industrial building',
    'player.insp.gwrCls.1252': 'tank, silo or storage',
    'player.insp.gwrCls.1261': 'culture / leisure',
    'player.insp.gwrCls.1262': 'museum / library',
    'player.insp.gwrCls.1263': 'school / research',
    'player.insp.gwrCls.1264': 'hospital / health care',
    'player.insp.gwrCls.1265': 'sports hall',
    'player.insp.gwrCls.1271': 'farm building',
    'player.insp.gwrCls.1272': 'church / place of worship',
    'player.insp.gwrCls.1273': 'monument / listed structure',
    'player.insp.gwrCls.1274': 'other structure',
    'player.insp.gwrCls.1275': 'other communal lodging',
    'player.insp.gwrCls.1276': 'livestock building',
    'player.insp.gwrCls.1277': 'crop-growing building',
    'player.insp.gwrCls.1278': 'other farm building',
    'player.insp.lift.funicular': 'Funicular',
    'player.insp.lift.gondola': 'Gondola',
    'player.insp.lift.cableCar': 'Aerial tramway',
    'player.insp.lift.chairLift': 'Chairlift',
    'player.insp.lift.mixedLift': 'Gondola + chairlift',
    'player.insp.lift.dragLift': 'Drag lift',
    'player.insp.lift.tBar': 'T-bar',
    'player.insp.lift.jBar': 'J-bar',
    'player.insp.lift.platter': 'Platter lift',
    'player.insp.lift.ropeTow': 'Rope tow',
    'player.insp.lift.magicCarpet': 'Magic carpet',
    'player.insp.lift.zipLine': 'Zip line',
    'player.insp.kind.building': 'Building',
    'player.insp.kind.trail': 'Path',
    'player.insp.kind.peak': 'Summit',
    'player.insp.kind.station': 'Station',
    'player.insp.kind.lift': 'Lift',
    'player.insp.kind.water': 'Water',
    'player.insp.kind.poi': 'Place',
    'player.insp.kind.ground': 'Terrain',
    'player.insp.kind.route': 'Route',
    'player.insp.kind.amenity': 'Amenity',
    'player.insp.kind.object': 'Object',
    'player.insp.oa.path1': 'path ≤ 1 m',
    'player.insp.oa.path2': 'path ≈ 2 m',
    'player.insp.oa.road3': 'track / road 3 m',
    'player.insp.oa.road4': 'road 4 m',
    'player.insp.oa.road6': 'road 6 m',
    'player.insp.oa.road8': 'road 8 m',
    'player.insp.oa.road10': 'road 10 m',
    'player.insp.oa.spur': 'marked route, no built path',
    'player.insp.oa.ferrata': 'via ferrata',
    'player.insp.oa.frag': 'path fragment',
    'player.insp.oa.other': 'other way',
    'player.insp.bel.hard': 'hard (sealed)',
    'player.insp.bel.natural': 'natural',
    'player.insp.vis.excellent': 'excellent — unmistakable',
    'player.insp.vis.good': 'good — the path is clear',
    'player.insp.vis.intermediate': 'intermediate — partly unclear',
    'player.insp.vis.bad': 'bad — often hard to follow',
    'player.insp.vis.horrible': 'horrible — barely visible',
    'player.insp.vis.no': 'no visible path',
    'player.insp.routeWord.hiking': 'hiking',
    'player.insp.routeWord.foot': 'walking',
    'player.insp.routeWord.mtb': 'mountain-bike',
    'player.insp.routeWord.bicycle': 'cycling',
    'player.insp.routeName.hiking': 'hiking route',
    'player.insp.routeName.foot': 'walking route',
    'player.insp.routeName.mtb': 'mountain-bike route',
    'player.insp.routeName.bicycle': 'cycling route',
    'player.insp.route.word': 'route',
    'player.insp.tag.backrest': 'backrest',
    'player.insp.tag.covered': 'covered',
    'player.insp.tag.drinkingWater': 'drinking water',
    'player.insp.tag.summitCross': 'summit cross',
    'player.insp.tag.historic': 'historic',
    'player.insp.src.bafuLakes': 'BAFU lake inventory (VECTOR25)',
    'player.insp.poi.peak': 'summit',
    'player.insp.poi.farpeak': 'summit (beyond the map)',
    'player.insp.poi.pass': 'mountain pass',
    'player.insp.poi.ridge': 'ridge',
    'player.insp.poi.village': 'village',
    'player.insp.poi.town': 'town',
    'player.insp.poi.city': 'city',
    'player.insp.poi.hamlet': 'hamlet',
    'player.insp.poi.suburb': 'district',
    'player.insp.poi.hotel': 'hotel',
    'player.insp.poi.hostel': 'hostel',
    'player.insp.poi.restaurant': 'restaurant',
    'player.insp.poi.cafe': 'café',
    'player.insp.poi.bar': 'bar',
    'player.insp.poi.alpineHut': 'alpine hut',
    'player.insp.poi.hut': 'hut',
    'player.insp.poi.viewpoint': 'viewpoint',
    'player.insp.poi.museum': 'museum',
    'player.insp.poi.gallery': 'gallery',
    'player.insp.poi.attraction': 'attraction',
    'player.insp.poi.church': 'church',
    'player.insp.poi.chapel': 'chapel',
    'player.insp.poi.station': 'lift / rail station',
    'player.insp.poi.lake': 'lake',
    'player.insp.poi.river': 'river',
    'player.insp.poi.hospital': 'hospital',
    'player.insp.obj.fence': 'Fence',
    'player.insp.obj.guardRail': 'Guard rail',
    'player.insp.obj.hedge': 'Hedge',
    'player.insp.obj.wall': 'Wall',
    'player.insp.obj.coping': 'Retaining wall',
    'player.insp.obj.pylon': 'Power pylon',
    'player.insp.obj.powerline': 'Power line',
    'player.insp.obj.mast': 'Antenna mast',
    'player.insp.obj.tower': 'Tower',
    'player.insp.obj.chimney': 'Chimney',
    'player.insp.obj.windturbine': 'Wind turbine',
    'player.insp.obj.silo': 'Silo',
    'player.insp.obj.utility': 'Utility structure',
    'player.insp.obj.fountain': 'Fountain',
    'player.insp.obj.monument': 'Monument',
    'player.insp.obj.skijump': 'Ski jump',
    'player.insp.obj.waterfall': 'Waterfall',
    'player.insp.obj.avalanche': 'Avalanche / rockfall barrier',
    'player.insp.obj.dam': 'Dam',
    'player.insp.obj.checkdam': 'Check dam',
    'player.insp.obj.jetty': 'Jetty',
    'player.insp.obj.chute': 'Bob run',
    'player.insp.obj.lane': 'Running track',
    'player.insp.obj.court': 'Sports ground',
    'player.insp.obj.basin': 'Water basin',
    'player.insp.obj.berm': 'Protective embankment',
    'player.insp.obj.generic': 'Structure',
    'player.insp.fence.chain': 'chain-link',
    'player.insp.fence.electric': 'electric',
    'player.insp.fence.wire': 'wire',
    'player.insp.fence.metal': 'metal bars / railing',
    'player.insp.fence.paling': 'paling',
    'player.insp.fence.board': 'solid board / panel',
    'player.insp.fence.rail': 'post and rail',
    'player.insp.fence.knee': 'knee rail',
    'player.insp.pylon.tower': 'lattice tower',
    'player.insp.pylon.pole': 'pole',
    'player.insp.pylon.portal': 'portal',
    'player.insp.pylon.terminal': 'terminal',
    'player.insp.art.antenneKlein': 'small antenna (mobile / relay)',
    'player.insp.art.antenneGross': 'large antenna',
    'player.insp.art.antenne': 'antenna',
    'player.insp.art.sendeturm': 'transmission tower',
    'player.insp.art.aussichtsturm': 'observation tower',
    'player.insp.art.wasserturm': 'water tower',
    'player.insp.art.kuehlturm': 'cooling tower',
    'player.insp.art.leuchtturm': 'lighthouse',
    'player.insp.art.turm': 'tower',
    'player.insp.art.kamin': 'chimney',
    'player.insp.art.windturbine': 'wind turbine',
    'player.insp.art.silo': 'silo',
    'player.insp.art.wasserversorgung': 'water supply',
    'player.insp.art.brunnen': 'fountain',
    'player.insp.art.quelle': 'spring',
    'player.insp.art.denkmal': 'monument',
    'player.insp.art.bildstock': 'wayside shrine',
    'player.insp.art.triangulationspyramide': 'triangulation pyramid',
    'player.insp.art.wasserfall': 'waterfall',
    'player.insp.art.sprungschanze': 'ski jump',
    'player.insp.art.schutzverbauung': 'avalanche / rockfall protection',
    'player.insp.art.gewaesserverbauung': 'river works',
    'player.insp.art.lawinenverbauung': 'avalanche barrier',
    'player.insp.art.trockenmauer': 'dry-stone wall',
    'player.insp.art.stuetzmauer': 'retaining wall',
    'player.insp.art.mauer': 'wall',
    'player.insp.art.stromleitung': 'power line',
    'player.insp.art.scheibenstand': 'shooting-range target wall',
    'player.insp.art.hafensteg': 'jetty',
    'player.insp.art.bobbahn': 'bob run',
    'player.insp.art.laufbahn': 'running track',
    'player.insp.art.staumauer': 'dam wall',
    'player.insp.art.schutzdamm': 'protective embankment',
    'player.insp.art.wehr': 'weir',
    'player.insp.art.wasserbecken': 'water basin',
    'player.insp.art.sportplatz': 'sports ground',
    'player.insp.art.hartbelagpiste': 'hard-court pitch',
    'player.insp.art.rollfeldHartbelag': 'paved apron',
    'player.insp.hfrom.tlmPoint': 'surveyed top (swissTLM3D point − ground)',
    'player.insp.hfrom.tlmOutline': 'surveyed top (swissTLM3D outline − ground)',
    'player.insp.hfrom.tlmLine': 'survey line over the ground (swissTLM3D, median)',
    'player.insp.hfrom.osm': 'OpenStreetMap height tag',
    'player.insp.hfrom.pole': 'typical pole (no OSM height)',
    'player.insp.hfrom.rule': 'the wall-top guard rail rule',
    'player.insp.hfrom.defaultTlm': 'typical for the class — swissTLM3D gives no usable top',
    'player.insp.hfrom.defaultOsm': 'typical for the class — no OSM height',
    'player.insp.val.asl': '{h} a.s.l.',
    'player.insp.row.type': 'Type',
    'player.insp.row.tlmClass': 'swissTLM3D class',
    'player.insp.row.name': 'Name',
    'player.insp.row.fenceType': 'Fence type',
    'player.insp.row.material': 'Material',
    'player.insp.row.coping': 'Coping',
    'player.insp.obj.copingSide': 'on the higher side of the line',
    'player.insp.row.voltage': 'Voltage',
    'player.insp.val.notTagged': 'not tagged',
    'player.insp.row.tlmVoltage': 'TLM voltage class',
    'player.insp.row.circuits': 'Circuits',
    'player.insp.row.supports': 'Supports',
    'player.insp.row.length': 'Length',
    'player.insp.row.openings': 'Openings',
    'player.insp.row.footprint': 'Footprint',
    'player.insp.obj.footprint': '{area} m² · outline {outline}',
    'player.insp.row.height': 'Height',
    'player.insp.obj.heightTypical': '{h} m (typical)',
    'player.insp.row.heightFrom': 'Height from',
    'player.insp.obj.surveyAtGround': 'the survey point lies at the ground',
    'player.insp.obj.implausibleFor': 'implausible for {what}',
    'player.insp.obj.anArt': 'an \'{art}\'',
    'player.insp.obj.itsClass': 'its class',
    'player.insp.row.surveyTop': 'Survey top',
    'player.insp.obj.surveyTop': '{top} a.s.l. = {dz} m over the ground — rejected, {why}',
    'player.insp.row.fallCrest': 'Crest',
    'player.insp.row.fall': 'Fall',
    'player.insp.obj.fallTo': '{h} m to {base}',
    'player.insp.row.base': 'Base',
    'player.insp.row.top': 'Top',
    'player.insp.row.ground': 'Ground',
    'player.insp.row.source': 'Source',
    'player.insp.obj.tlmRelease': 'swissTLM3D (swisstopo) · release {rel}',
    'player.insp.row.drawnBy': 'Drawn by',
    'player.insp.obj.ruleDrawn': 'rule — a guard rail on a wall top (no map object)',
    'player.insp.riding': 'Riding',
    'player.insp.title.routeRef': 'Route {ref}',
    'player.insp.trail.walkBoth': '{there} one way · {back} back',
    'player.insp.row.official': 'Official',
    'player.insp.trail.extraOfficial': '{mark} (swissTLM3D), not mapped in OSM',
    'player.insp.row.width': 'Width',
    'player.insp.row.surface': 'Surface',
    'player.insp.row.thisSection': 'This section',
    'player.insp.row.inGame': 'In the game',
    'player.insp.trail.mapOnly': 'map only — not a walkable path here',
    'player.insp.row.grade': 'Grade',
    'player.insp.trail.noGrade': 'no SAC grade tagged',
    'player.insp.row.officialClass': 'Official class',
    'player.insp.trail.setsMark': '{mark} (swissTLM3D) — it sets the mark',
    'player.insp.row.viaFerrata': 'Via ferrata',
    'player.insp.trail.huesler': 'K{n} (Hüsler scale)',
    'player.insp.row.mtb': 'MTB scale',
    'player.insp.row.trackType': 'Track type',
    'player.insp.row.visibility': 'Visibility',
    'player.insp.row.incline': 'Incline',
    'player.insp.trail.uphill': 'uphill (along the line)',
    'player.insp.trail.downhill': 'downhill (along the line)',
    'player.insp.row.vehicles': 'Vehicles',
    'player.insp.row.wholePath': 'Whole path',
    'player.insp.row.walkingTime': 'Walking time',
    'player.insp.h.onRoutes': 'On routes',
    'player.insp.row.route': 'Route',
    'player.insp.row.network': 'Network',
    'player.insp.row.fromTo': 'From → to',
    'player.insp.row.loop': 'Loop',
    'player.insp.route.loopYes': 'yes — ends where it starts',
    'player.insp.row.operator': 'Operator',
    'player.insp.row.website': '🔗 Website',
    'player.insp.h.insideMap': 'Inside this map',
    'player.insp.row.stage': 'Stage',
    'player.insp.route.nOf': '{n} of {total}',
    'player.insp.row.guide': 'Guide',
    'player.insp.route.following': 'following stage {n} — the gold beacon walks ~{ahead} m ahead',
    'player.insp.route.followingRev': 'following stage {n} (reversed) — the gold beacon walks ~{ahead} m ahead',
    'player.insp.act.stopGuide': 'Stop guiding',
    'player.insp.res.guideStopped': 'guide stopped',
    'player.insp.act.reverse': 'Reverse',
    'player.insp.res.guideReversed': 'guiding the other way',
    'player.insp.act.guideCombat': 'Guide me (combat on)',
    'player.insp.act.guide': 'Guide me',
    'player.insp.res.guiding': 'guiding along {name} — follow the gold beacon (~{ahead} m ahead)',
    'player.insp.res.theRoute': 'the route',
    'player.insp.res.stageOf': 'stage {n} of {total}',
    'player.insp.act.prevStage': 'Prev stage',
    'player.insp.act.nextStage': 'Next stage',
    'player.insp.val.yes': 'yes',
    'player.insp.val.no': 'no',
    'player.insp.row.shop': 'Shop',
    'player.insp.h.shops': 'Shops ({n})',
    'player.insp.val.shop': 'shop',
    'player.insp.row.stopNumber': 'Stop number',
    'player.insp.row.shelter': 'Shelter',
    'player.insp.row.bench': 'Bench',
    'player.insp.row.passHeight': 'Pass height',
    'player.insp.row.details': 'Details',
    'player.insp.val.coarse': '{label} (coarse)',
    'player.insp.row.tourism': 'Tourism',
    'player.insp.row.historic': 'Historic',
    'player.insp.row.office': 'Office',
    'player.insp.row.address': 'Address',
    'player.insp.val.regLoading': 'loading the register…',
    'player.insp.val.noAddress': 'no address on file',
    'player.insp.row.registerName': 'Register name',
    'player.insp.row.buildingClass': 'Building class',
    'player.insp.row.category': 'Category',
    'player.insp.row.built': 'Built',
    'player.insp.val.before': 'before {y}',
    'player.insp.row.storeys': 'Storeys',
    'player.insp.row.dwellings': 'Dwellings',
    'player.insp.row.protected': 'Protected',
    'player.insp.val.eavesRidge': '{h} m (eaves/ridge)',
    'player.insp.res.pointThere': 'the gold beacon + the compass strip point there',
    'player.insp.row.ridgeCrest': 'Crest',
    'player.insp.row.prominence': 'Prominence',
    'player.insp.row.trail': 'Trail',
    'player.insp.val.pathEnds': '{grade} — a path ends within 150 m',
    'player.insp.val.line': 'line',
    'player.insp.row.lines': 'Lines',
    'player.insp.res.notNow': 'not now — wait for the car',
    'player.insp.row.lineLength': 'Line length',
    'player.insp.row.vertical': 'Vertical',
    'player.insp.water.reservoirNatural': 'reservoir (natural lake)',
    'player.insp.water.reservoir': 'reservoir',
    'player.insp.water.naturalLake': 'natural lake',
    'player.insp.row.officialName': 'Official name',
    'player.insp.row.waterLevel': 'Water level',
    'player.insp.row.waterTemp': 'Water temp',
    'player.insp.row.maxDepth': 'Max depth',
    'player.insp.row.area': 'Area',
    'player.insp.row.shore': 'Shore length',
    'player.insp.row.elevation': 'Elevation',
    'player.insp.row.volume': 'Volume',
    'player.insp.val.mioM3': '{v} million m³',
    'player.insp.row.usableVolume': 'Usable volume',
    'player.insp.row.regulated': 'Regulated',
    'player.insp.row.gauge': 'Gauge',
    'player.insp.val.unnamed': 'unnamed',
    'player.insp.row.range': 'Range',
    'player.insp.val.openSkyLine': 'open sky — no surface along this line',
    'player.insp.val.measuring': 'measuring — terrain loading',
    'player.insp.val.noClassMap': 'no class map here',
    'player.insp.row.slope': 'Slope',
    'player.insp.row.faces': 'Faces',
    'player.insp.h.position': 'Position',
    'player.insp.row.game': 'Game',
    'player.insp.h.near': 'What\'s near',
    'player.insp.title.officialPath': 'Official path (swissTLM3D)',
    'player.insp.title.unnamedPath': 'Unnamed path',
    'player.insp.title.openSky': 'Open sky',
    'player.insp.title.target': 'Target',
    'player.insp.src.optic': 'optic range',
    'player.insp.src.ray': 'terrain ray',
    'player.insp.src.mapTap': 'map tap',
    'player.insp.src.noRange': 'no range (sky)',
    'player.insp.src.osm': '© OpenStreetMap contributors',
    'player.insp.src.dem': 'swisstopo DEM',
    'player.insp.src.nearestReg': 'nearest register entry',
    'player.insp.src.sacScale': 'SAC hiking scale',
    'player.insp.src.routeRel': 'route relations',
    'player.insp.src.bafuGauges': 'BAFU hydrometric network',
    'player.insp.src.classMap': 'class map',
    'player.insp.act.beaconOff': 'Beacon off',
    'player.insp.act.beacon': 'Beacon',
    'player.insp.res.beaconCleared': 'beacon cleared',
    'player.insp.res.beaconSet': 'beacon set on {name}',
    'player.insp.act.look': 'Look',
    'player.insp.act.map': 'Map',
    'player.insp.res.pinnedWrist': 'pinned on your wrist map',
    'player.insp.res.pinnedMap': 'pinned on the map',
    'player.insp.act.beamOutside': 'Beam (outside the map)',
    'player.insp.act.beamStart': 'Beam — start here in 3D',
    'player.insp.act.beamThere': 'Beam to there',
    'player.insp.act.beamCharging': 'beaming…',
    'player.insp.act.beamEsc': 'Esc cancels',
    'player.insp.res.refusedOutside': 'refused — outside the map',
    'player.insp.alsoHere': 'also here',
    'player.insp.res.failed': 'that did not work',
    'player.insp.res.beaming': 'already beaming…',
    'player.insp.res.refusedCombat': 'refused — combat is on',
    'player.insp.res.refusedServer': 'refused — combat on, out of bounds, or another beam within 2 s',
    'player.insp.res.beamed': '✓ beamed — {h} m',
    'player.insp.res.noReply': 'refused — no reply from the server',
    // @@EN northlock
    'player.map.lockOn': 'North locked — twist to turn · tap to follow your phone',
    'player.map.lockOff': 'Follows your phone — tap to lock north',
    // @@EN-END
  },
  de: {
    // @@DE briefing
    'player.brief.mouseAria': 'Maus: Linksklick zeigt Infos, Rechtsklick öffnet die Karte, Rad zoomt, Mausbewegung schaut sich um',
    'player.brief.phoneAria': 'Handy-Bildschirm: Der Stick läuft, ein Tipp in die Mitte zeigt Infos, Slider oder Pinch zoomt, die Minimap öffnet die Karte, das Schloss hält die Ansicht',
    'player.brief.ctrlsAria': 'Die zwei Controller: Stick, zwei Tasten, Trigger, Griff',
    'player.brief.svgInspect': 'INFO',
    'player.brief.svgMap': 'KARTE',
    'player.brief.svgZoom': 'ZOOM',
    'player.brief.svgLook': 'UMSEHEN',
    'player.brief.svgMonocular': 'das Monokular',
    'player.brief.svgMap2d': '2D-Karte',
    'player.brief.svgInOut': 'rein · raus',
    'player.brief.svgMoveMouse': 'Maus bewegen',
    'player.brief.svgHold': 'HALTEN',
    'player.brief.svgTap': 'TIPPEN',
    'player.brief.svgWalk': 'LAUFEN',
    'player.brief.svgTheView': 'die Ansicht',
    'player.brief.svgTapIt': 'antippen',
    'player.brief.svgInspectLow': 'Info',
    'player.brief.svgOrPinch': 'oder Pinch',
    'player.brief.svgTheStick': 'der Stick',
    'player.brief.svgLeft': 'LINKS',
    'player.brief.svgRight': 'RECHTS',
    'player.brief.actTap': 'Tippe auf',
    'player.brief.actVr': 'Zeig + Trigger auf',
    'player.brief.actClick': 'Klick auf',
    'player.brief.othersTitle': 'Andere sind da',
    'player.brief.othersSub': 'ihre Namen über den Avataren',
    'player.brief.othersVoice': 'du hörst sie in der Nähe',
    'player.brief.othersNoVoice': '🎤 Sprache auf der Startseite',
    'player.brief.leadPre': 'Die <b>Karte</b> der Welt. <b>{act}</b> einen Spot → seine Infokarte → <b>⤳ Beam</b> startet dich dort in 3D.',
    'player.brief.leadIn': '<b>{act}</b> einen Spot → seine Infokarte: <b>👁 Hinschauen</b> dreht dich hin, <b>⤳ Beam</b> bringt dich hin.',
    'player.brief.drag': 'Ziehen',
    'player.brief.dragSub': 'bewegt die Karte',
    'player.brief.pinch': 'Pinch',
    'player.brief.zoomOrPm': 'Zoom · oder + −',
    'player.brief.tapSpot': 'Spot antippen',
    'player.brief.cardSub': 'seine Infokarte: Pfade, Orte, Höhen',
    'player.brief.beamPre': 'dort in 3D starten',
    'player.brief.beamGo': 'dorthin',
    'player.brief.tapRed': 'Roten Spot antippen',
    'player.brief.redPre': 'sofort dort in 3D starten',
    'player.brief.redGo': 'sofort hinbeamen',
    'player.brief.chipsSub': 'MTB · Services',
    'player.brief.players': 'Spieler',
    'player.brief.playersDots': 'farbige Punkte mit Namen',
    'player.brief.playersTap': 'tipp einen an: deine Minimap zeigt den Weg',
    'player.brief.playersClick': 'klick einen an: deine Minimap zeigt den Weg',
    'player.brief.back3d': 'zurück in 3D',
    'player.brief.vrPoint': 'Zeigen + Trigger',
    'player.brief.vrPointSub': 'der Controller ist der Zeiger',
    'player.brief.vrHold': 'Trigger halten + bewegen',
    'player.brief.zoom': 'Zoom',
    'player.brief.vrTrigSpot': 'Spot antriggern',
    'player.brief.beamVrPre': 'ins Headset, dorthin',
    'player.brief.vrRed': 'Zeigen + Trigger auf roten Spot',
    'player.brief.redVrPre': 'sofort ins Headset, dorthin',
    'player.brief.wheel': 'Rad',
    'player.brief.clickSpot': 'Spot anklicken',
    'player.brief.clickRed': 'Roten Spot anklicken',
    'player.brief.inHeadset': 'Im Headset',
    'player.brief.theMap': 'Die Karte',
    'player.brief.inWorld': 'In der Welt',
    'player.brief.pointPhone': 'Handy ausrichten',
    'player.brief.pointPhoneSub': 'zum Umsehen · oder ziehen',
    'player.brief.tapCentre': 'Mitte antippen',
    'player.brief.tapCentreSub': 'was da ist · einsteigen am Stationsschild',
    'player.brief.pinchSlider': 'Pinch · Slider',
    'player.brief.pinchSliderSub': 'Zoom · Slider doppelt tippen: 1×',
    'player.brief.tipFlat': 'Handy flach kippen',
    'player.brief.tipFlatSub': 'die Karte · wieder aufrichten: zurück',
    'player.brief.jump': 'SPRUNG',
    'player.brief.jumpSub': 'der Knopf unten rechts',
    'player.brief.jet': 'Jet-Suit',
    'player.brief.jetSub': 'zündet in der Luft · fliegt, wohin du schaust',
    'player.brief.gpsSub': 'du gehst, wo du wirklich gehst',
    'player.brief.clickView': 'Ansicht anklicken',
    'player.brief.clickViewSub': 'die Maus steuert den Blick',
    'player.brief.escSub': 'gibt die Maus wieder frei',
    'player.brief.keyMove': 'laufen',
    'player.brief.keySprint': 'sprinten',
    'player.brief.keyJump': 'springen',
    'player.brief.keyClimb': 'klettern (halten)',
    'player.brief.keyBike': 'Bike',
    'player.brief.keyMap': 'Karte',
    'player.brief.keySign': 'Stationsschild',
    'player.brief.keyMic': 'Mikro an/aus',
    'player.brief.keyHelp': 'diese Hilfe',
    'player.brief.jetDesk': 'zündet in der Luft · fliegt, wohin du schaust · {s} bremst',
    'player.brief.bikeSub': '{w}{s} Gas / Bremse · {a}{d} lenken · {q} Auto-Folgen',
    'player.brief.lifts': 'Lifte fahren',
    'player.brief.liftsDesk': 'an der Station: auf eine Schildzeile zielen, klicken (oder F / G)',
    'player.brief.liftsVr': 'an der Station: A / B oder Zeigen + Trigger auf eine Schildzeile',
    'player.brief.handLeft': 'Linke Hand',
    'player.brief.handRight': 'Rechte Hand',
    'player.brief.cStick': 'Stick',
    'player.brief.cStickClick': 'Stick-Klick',
    'player.brief.cStickUD': 'Stick ↑ ↓',
    'player.brief.cStickLR': 'Stick ← →',
    'player.brief.cTrigger': 'Trigger',
    'player.brief.cGrip': 'Griff',
    'player.brief.lStick': 'lauf, wohin du schaust: ↑↓ vor / zurück · ←→ seitlich (voll = rennen) — Jet-Suit: ↑ sinken · ↓ steigen · ←→ lenken',
    'player.brief.lStickClick': 'die Karte — öffnen / schliessen',
    'player.brief.lX': 'Bike an / aus',
    'player.brief.lYMic': 'Mikro an / aus',
    'player.brief.lY': 'Bike: auto ⇄ manuell',
    'player.brief.lTrigger': 'die Karte — öffnen / schliessen · ein Panel anklicken',
    'player.brief.lGrip': 'klettern — Fels greifen',
    'player.brief.rStickUD': 'rein- / rauszoomen (ein Fenster vor dir, mit Beschriftung) — nicht im Flug',
    'player.brief.rStickLR': 'drehen: fliessend oder in Rasten 30° / 45° (☰ → Komfort) — nicht im Flug',
    'player.brief.rStickClick': 'springen — startet den Jet-Suit',
    'player.brief.rA': 'das ☰-Menü — öffnen / schliessen (überall)',
    'player.brief.rB': 'Infokarte / Panel schliessen · Stationsschild: 2. Aktion (1.: zeigen + Trigger)',
    'player.brief.rTrigger': 'was da ist — die Infokarte des Spots, auf den der Laser zeigt (⤳ Dorthin beamen) · eine Schildzeile · ein Panel anklicken',
    'player.brief.rGrip': 'klettern',
    'player.brief.tFinger': 'Finger am Trigger',
    'player.brief.tFingerSub': 'rechte Hand: der Laser + ein Punkt auf dem, worauf du zeigst · ziehen = seine Infokarte',
    'player.brief.tHudSub': 'Kompass oben · Höhe, Neigung, Boden, Zoom unten (☰ → HUD an / aus)',
    'player.brief.tWrist': 'Linkes Handgelenk — drehen zum Hinschauen',
    'player.brief.tWristMap': 'die Karte (Zeigen + Trigger = Kartenpanel)',
    'player.brief.tMenu': 'A — ☰ Menü',
    'player.brief.tMenuSub': 'Karte · Hilfe · Zentrieren · Komfort · HUD · VR beenden',
    'player.brief.tMapPanel': 'Kartenpanel',
    'player.brief.tMapPanelSub': 'Trigger auf Spot = markieren · nochmal auf die Markierung / ⤳ Beam here = beamen · ziehen = verschieben',
    'player.brief.tMapRed': 'Kartenpanel: ein roter Spot',
    'player.brief.tMapRedSub': 'Zeigen + Trigger darauf = sofort hinbeamen',
    'player.brief.vrEnd': 'Beendest du die VR-Sitzung, bist du zurück auf dieser Karte.',
    'player.brief.devPhone': 'Handy',
    'player.brief.devDesktop': 'Desktop',
    'player.brief.againBar': '? (obere Leiste) zeigt das hier nochmal',
    'player.brief.againFlat': '? (oben links) oder die ?-Taste zeigt das hier nochmal',
    'player.brief.againMobile': '? (oben links, unter 🔒) zeigt das hier nochmal',
    'player.brief.gpsBeam': '📍 Zu meiner Position beamen',
    // @@DE playermap
    'player.map.hintFlat': 'ziehen zum Verschieben · Rad zum Zoomen · Spot anklicken zum Hinbeamen',
    'player.map.hintMobile': 'Pinch zum Zoomen · Spot antippen zum Hinbeamen',
    'player.map.hintVr': 'Zeigen + Trigger auf einen Spot zum Hinbeamen',
    'player.map.verbFlat': 'Klick auf',
    'player.map.verbMobile': 'Tippe auf',
    'player.map.verbVr': 'Zeig + Trigger auf',
    'player.map.closeFlat': 'Schliessen (Rechtsklick / N / Esc)',
    'player.map.closeMobile': 'Schliessen',
    'player.map.closeVr': 'Schliessen (Zeigen + Trigger)',
    'player.map.headingUp': 'Blickrichtung oben — tippen für Norden oben',
    'player.map.northUp': 'Norden oben — tippen für Blickrichtung oben',
    'player.map.leave': 'Karte verlassen',
    'player.map.dirN': 'N',
    'player.map.dirNE': 'NO',
    'player.map.dirE': 'O',
    'player.map.dirSE': 'SO',
    'player.map.dirS': 'S',
    'player.map.dirSW': 'SW',
    'player.map.dirW': 'W',
    'player.map.dirNW': 'NW',
    'player.map.loading': 'Karte lädt… {hint}',
    'player.map.combat': 'Kampf ist an — die Karte zeigt nur dich',
    'player.map.following': 'Du folgst {name} — der Strahl leuchtet heller. {verb} den Spieler nochmal zum Beenden.',
    'player.map.others1': '1 anderer Spieler in der Welt — {verb} ihn zum Folgen',
    'player.map.othersN': '{n} andere Spieler in der Welt — {verb} einen zum Folgen',
    'player.map.details': '{verb} etwas auf der Karte für Details',
    // @@DE station
    'player.station.gondola': 'Gondel',
    'player.station.cableCar': 'Seilbahn',
    'player.station.chairlift': 'Sessellift',
    'player.station.train': 'Bahn',
    'player.station.departsIn': 'Abfahrt in {cd} s',
    'player.station.riding': 'Fahrt läuft…',
    'player.station.exit': '◎ {w} verlassen',
    'player.station.waitCabin': 'Einsteigen: {w} nach {dest} — nächste Kabine kommt…',
    'player.station.waitChair': 'Aufsitzen: {w} nach {dest} — nächster Sessel kommt…',
    'player.station.waitTrain': 'Einsteigen: {w} nach {dest} — {w} noch nicht da, warte…',
    'player.station.sitOn': '◎ Aufsitzen: {w} nach {dest}',
    'player.station.sitOnDep': '◎ Aufsitzen: {w} nach {dest} · Abfahrt {cd}s',
    'player.station.board': '◎ Einsteigen: {w} nach {dest}',
    'player.station.boardDep': '◎ Einsteigen: {w} nach {dest} · Abfahrt {cd}s',
    'player.station.aim': 'zielen & schiessen zum Auswählen',
    // @@DE misc
    'player.station.funicular': 'Standseilbahn',
    'player.beacon.player': 'Spieler-{id}',
    // @@DE mobile
    'player.mob.fire': 'FEUER',
    'player.mob.jump': 'SPRUNG',
    'player.mob.inspect': 'Untersuchen',
    'player.mob.gpsLabel': 'GPS',
    'player.mob.close': 'Schliessen',
    'player.mob.retry': 'Nochmal versuchen',
    'player.mob.rotate.title': 'Dreh dein Handy quer',
    'player.mob.rotate.body': 'GEO-VR läuft im Querformat — Stick, Buttons und Sicht brauchen die Breite.',
    'player.mob.rotate.portrait': 'Trotzdem hochkant spielen',
    'player.mob.lockView': 'Sicht sperren',
    'player.mob.unlockView': 'Sicht entsperren',
    'player.mob.closeMap': 'Karte schliessen',
    'player.mob.map': 'Karte',
    'player.mob.gps.unavailable': 'GPS ist nicht verfügbar',
    'player.mob.gps.noteBlocked': 'Verlass zuerst den Vollbildmodus — diese Schritte beginnen in der Adressleiste, und die ist hier versteckt.',
    'player.mob.gps.notePolicy': 'Daran kannst du auf diesem Handy nichts ändern — der Server muss einen anderen Header schicken.',
    // @@DE layers
    'player.layers.net.international': 'international',
    'player.layers.net.national': 'national',
    'player.layers.net.regional': 'regional',
    'player.layers.net.local': 'lokal',
    'player.layers.amenity.saddle': 'Sattel',
    'player.layers.amenity.cross': 'Kreuz',
    'player.layers.amenity.drinking_water': 'Trinkwasser',
    'player.layers.amenity.spring': 'Quelle',
    'player.layers.amenity.toilets': 'Toiletten',
    'player.layers.amenity.firepit': 'Feuerstelle',
    'player.layers.amenity.bbq': 'Grillstelle',
    'player.layers.amenity.picnic_table': 'Picknicktisch',
    'player.layers.amenity.shelter': 'Unterstand',
    'player.layers.amenity.bench': 'Bank',
    'player.layers.amenity.waste_basket': 'Abfalleimer',
    'player.layers.amenity.board': 'Infotafel',
    'player.layers.amenity.map': 'Kartentafel',
    'player.layers.amenity.route_marker': 'Wegmarkierung',
    'player.layers.amenity.historic': 'Historische Stätte',
    'player.layers.amenity.artwork': 'Kunstwerk',
    'player.layers.amenity.charging_station': 'Ladestation',
    'player.layers.amenity.parking': 'Parkplatz',
    'player.layers.amenity.bicycle_parking': 'Veloparkplatz',
    'player.layers.amenity.playground': 'Spielplatz',
    'player.layers.amenity.survey_point': 'Vermessungspunkt',
    'player.layers.amenity.bus_stop': 'Bushaltestelle',
    'player.layers.amenity.summitCross': 'Gipfelkreuz',
    'player.layers.street.gate': 'Tor',
    'player.layers.street.swing_gate': 'Schwenktor',
    'player.layers.street.kissing_gate': 'Durchschlupf',
    'player.layers.street.stile': 'Überstieg',
    'player.layers.street.lift_gate': 'Schranke',
    'player.layers.street.bollard': 'Poller',
    'player.layers.street.barrier': 'Strassensperre',
    // @@DE vrui
    'player.vr.menu.title': 'Menü',
    'player.vr.menu.map': '🗺  Karte — zeigen + Trigger zum Beamen',
    'player.vr.menu.help': '?  Hilfe',
    'player.vr.menu.recenter': '⟲  Zentrieren',
    'player.vr.ctrlAsleep': 'Controller schlafen: eine beliebige Controller-Taste drücken',
    'player.vr.menu.comfort': 'Komfort — Drehen mit rechtem Stick',
    'player.vr.menu.smooth': 'Fliessend',
    'player.vr.menu.snap': 'Stufen',
    'player.vr.menu.hudOn': 'HUD an — Kompass · Status (tippen: aus)',
    'player.vr.menu.hudOff': 'HUD aus (tippen: an)',
    'player.vr.menu.picture': 'Bild (Quest)',
    'player.vr.menu.qp.current': '4× AA (bisher)',
    'player.vr.menu.qp.balanced': '2× AA',
    'player.vr.menu.qp.steady': 'Ruhig 72',
    'player.vr.status.qp.current': 'Bild: 4× AA wie bisher (halbe Bildrate in schweren Ansichten)',
    'player.vr.status.qp.balanced': 'Bild: ausgewogen (2× AA, leichterer Boden)',
    'player.vr.status.qp.steady': 'Bild: ruhige Bildrate (kein AA, leichterer Boden)',
    'player.vr.menu.beam': 'Beam — die Landung',
    'player.vr.menu.beamFly': 'Herabfliegen',
    'player.vr.menu.beamInstant': 'Sofort',
    'player.vr.menu.exit': '⏏  VR beenden — zurück zur Kartenseite',
    'player.vr.menu.back': '‹ Menü',
    'player.vr.help.title': 'Steuerung — VR-Controller',
    'player.vr.help.left': 'Linker Controller',
    'player.vr.help.right': 'Rechter Controller',
    'player.vr.help.bike': 'Bike · Jet-Suit',
    'player.vr.help.pointing': 'Zeigen',
    'player.vr.help.k.stick': 'Stick',
    'player.vr.help.k.stickClick': 'Stick-Klick',
    'player.vr.help.k.grip': 'Grifftaste',
    'player.vr.help.k.trigger': 'Trigger',
    'player.vr.help.k.stickUD': 'Stick ↑↓',
    'player.vr.help.k.stickLR': 'Stick ←→',
    'player.vr.help.k.leftStick': 'linker Stick',
    'player.vr.help.k.jetsuit': 'Jet-Suit',
    'player.vr.help.k.finger': 'Finger am Trigger',
    'player.vr.help.k.wrist': 'linkes Handgelenk',
    'player.vr.help.k.map': 'Karte',
    'player.vr.help.k.mapRed': 'Karte · roter Punkt',
    'player.vr.help.walk': 'geh, wohin du schaust: ↑↓ vor / zurück, ←→ seitwärts (ganz = rennen)',
    'player.vr.help.mapToggle': 'die Karte — öffnen / schliessen',
    'player.vr.help.bikeOnOff': 'aufs Bike / vom Bike',
    'player.vr.help.mic': 'Mikro an / aus (Voice an) · auf dem Bike: Auto-Folgen ⇄ manuell',
    'player.vr.help.climbRock': 'Fels oder Wand packen zum Klettern',
    'player.vr.help.trigger': 'die Daten am Punkt: Infokarte von dem, worauf der Laser zeigt (⤳ Dorthin beamen) · Panel klicken',
    'player.vr.help.triggerMap': 'die Karte — öffnen / schliessen · Panel klicken',
    'player.vr.help.zoom': 'zoomen rein / raus — ein Fenster vor dir (zurück auf 1× = weg)',
    'player.vr.help.turn': 'drehen — fliessend oder in Stufen (☰ → Komfort)',
    'player.vr.help.jump': 'springen — startet den Jet-Suit (dann fliegt der linke Stick)',
    'player.vr.help.menuA': 'dieses Menü — öffnen / schliessen · Zeilen am Stationsschild: zeigen + Trigger',
    'player.vr.help.closeB': 'Infokarte / Panel schliessen · an einer Station: zweite Aktion',
    'player.vr.help.climb': 'packen zum Klettern',
    'player.vr.help.throttle': 'Gas ↑↓ · lenken ←→ (Auto-Folgen: antippen = Blinker)',
    'player.vr.help.jetsuit': 'L-Stick zurück = steigen · vor = sinken · ←→ lenkt · Tempo automatisch',
    'player.vr.help.laser': 'der rechte Laser + sein Punkt auf dem, worauf du zeigst',
    'player.vr.help.wrist': 'drehen und hinschauen: die Karte',
    'player.vr.help.mapMark': 'Trigger auf einen Ort = markieren · nochmals / ⤳ Hierher beamen = beamen',
    'player.vr.help.mapRed': 'Trigger drauf = sofort dorthin beamen (Kampf aus)',
    'player.vr.status.recentred': 'zentriert — vorne ist, wohin du schaust',
    'player.vr.status.beamNext': 'ab dem nächsten Beam',
    'player.vr.status.noRecenter': 'Zentrieren geht hier nicht',
    'player.vr.status.outside': 'ausserhalb der Karte',
    'player.vr.status.combatNoBeam': 'Kampf ist an — kein Beamen',
    'player.vr.status.beaming': '⤳ Beamen…',
    'player.vr.status.refused': 'abgelehnt — Kampf an, ausserhalb oder schon ein Beam in den letzten 2 s',
    'player.vr.status.noReply': 'abgelehnt — keine Antwort vom Server',
    'player.vr.map.combat': 'Kampf ist an — die Karte zeigt nur dich; kein Beamen',
    'player.vr.map.markAgain': 'Nochmals auf die Markierung, oder ⤳ Hierher beamen — ziehen zum Verschieben',
    'player.vr.map.spots': 'Trigger: roter Punkt = dorthin beamen · anderer Ort = markieren — ziehen zum Verschieben',
    'player.vr.map.point': 'Zeigen + Trigger auf einen Ort = markieren — ziehen zum Verschieben',
    'player.vr.map.clear': 'Löschen',
    'player.vr.map.beamHere': '⤳ Hierher beamen',
    'player.vr.map.asl': '{m} m ü. M.',
    // @@DE scope
    'player.scope.n': 'N',
    'player.scope.ne': 'NO',
    'player.scope.e': 'O',
    'player.scope.se': 'SO',
    'player.scope.s': 'S',
    'player.scope.sw': 'SW',
    'player.scope.w': 'W',
    'player.scope.nw': 'NW',
    'player.scope.mag': 'ZOOM {zoom}×',
    'player.scope.lrf': 'Laser',
    // @@DE inspect
    'player.insp.dir.n': 'N',
    'player.insp.dir.ne': 'NO',
    'player.insp.dir.e': 'O',
    'player.insp.dir.se': 'SO',
    'player.insp.dir.s': 'S',
    'player.insp.dir.sw': 'SW',
    'player.insp.dir.w': 'W',
    'player.insp.dir.nw': 'NW',
    'player.insp.gwrCat.1010': 'Notunterkunft',
    'player.insp.gwrCat.1020': 'nur Wohnen',
    'player.insp.gwrCat.1030': 'Wohnen mit Nebennutzung',
    'player.insp.gwrCat.1040': 'teilweise Wohnen',
    'player.insp.gwrCat.1060': 'ohne Wohnnutzung',
    'player.insp.gwrCat.1080': 'Sonderbau',
    'player.insp.gwrCls.1110': 'Einfamilienhaus',
    'player.insp.gwrCls.1121': 'Zweifamilienhaus',
    'player.insp.gwrCls.1122': 'Mehrfamilienhaus',
    'player.insp.gwrCls.1130': 'Wohngebäude für Gemeinschaften',
    'player.insp.gwrCls.1211': 'Hotel',
    'player.insp.gwrCls.1212': 'Kurzzeitunterkunft',
    'player.insp.gwrCls.1220': 'Bürogebäude',
    'player.insp.gwrCls.1230': 'Laden / Handel',
    'player.insp.gwrCls.1231': 'Restaurant / Bar',
    'player.insp.gwrCls.1241': 'Verkehrsgebäude (Bahnhof, Terminal)',
    'player.insp.gwrCls.1242': 'Garage',
    'player.insp.gwrCls.1251': 'Industriegebäude',
    'player.insp.gwrCls.1252': 'Tank, Silo oder Lager',
    'player.insp.gwrCls.1261': 'Kultur / Freizeit',
    'player.insp.gwrCls.1262': 'Museum / Bibliothek',
    'player.insp.gwrCls.1263': 'Schule / Forschung',
    'player.insp.gwrCls.1264': 'Spital / Gesundheit',
    'player.insp.gwrCls.1265': 'Sporthalle',
    'player.insp.gwrCls.1271': 'landwirtschaftliches Gebäude',
    'player.insp.gwrCls.1272': 'Kirche / Kultusgebäude',
    'player.insp.gwrCls.1273': 'Denkmal / geschütztes Bauwerk',
    'player.insp.gwrCls.1274': 'anderer Hochbau',
    'player.insp.gwrCls.1275': 'andere Gemeinschaftsunterkunft',
    'player.insp.gwrCls.1276': 'Stall',
    'player.insp.gwrCls.1277': 'Gewächshaus / Pflanzenbau',
    'player.insp.gwrCls.1278': 'anderes landwirtschaftliches Gebäude',
    'player.insp.lift.funicular': 'Standseilbahn',
    'player.insp.lift.gondola': 'Gondelbahn',
    'player.insp.lift.cableCar': 'Luftseilbahn',
    'player.insp.lift.chairLift': 'Sesselbahn',
    'player.insp.lift.mixedLift': 'Gondel- + Sesselbahn',
    'player.insp.lift.dragLift': 'Schlepplift',
    'player.insp.lift.tBar': 'Bügellift',
    'player.insp.lift.jBar': 'Einerbügel',
    'player.insp.lift.platter': 'Tellerlift',
    'player.insp.lift.ropeTow': 'Seillift',
    'player.insp.lift.magicCarpet': 'Förderband',
    'player.insp.lift.zipLine': 'Seilrutsche',
    'player.insp.kind.building': 'Gebäude',
    'player.insp.kind.trail': 'Pfad',
    'player.insp.kind.peak': 'Gipfel',
    'player.insp.kind.station': 'Station',
    'player.insp.kind.lift': 'Lift',
    'player.insp.kind.water': 'Gewässer',
    'player.insp.kind.poi': 'Ort',
    'player.insp.kind.ground': 'Gelände',
    'player.insp.kind.route': 'Route',
    'player.insp.kind.amenity': 'Einrichtung',
    'player.insp.kind.object': 'Objekt',
    'player.insp.oa.path1': 'Pfad ≤ 1 m',
    'player.insp.oa.path2': 'Pfad ≈ 2 m',
    'player.insp.oa.road3': 'Fahrweg / Strasse 3 m',
    'player.insp.oa.road4': 'Strasse 4 m',
    'player.insp.oa.road6': 'Strasse 6 m',
    'player.insp.oa.road8': 'Strasse 8 m',
    'player.insp.oa.road10': 'Strasse 10 m',
    'player.insp.oa.spur': 'markierte Route, kein gebauter Weg',
    'player.insp.oa.ferrata': 'Klettersteig',
    'player.insp.oa.frag': 'Wegstück',
    'player.insp.oa.other': 'anderer Weg',
    'player.insp.bel.hard': 'hart (Hartbelag)',
    'player.insp.bel.natural': 'natürlich',
    'player.insp.vis.excellent': 'ausgezeichnet — unverkennbar',
    'player.insp.vis.good': 'gut — der Pfad ist klar',
    'player.insp.vis.intermediate': 'mittel — teils unklar',
    'player.insp.vis.bad': 'schlecht — oft schwer zu verfolgen',
    'player.insp.vis.horrible': 'miserabel — kaum sichtbar',
    'player.insp.vis.no': 'kein sichtbarer Pfad',
    'player.insp.routeWord.hiking': 'Wandern',
    'player.insp.routeWord.foot': 'zu Fuss',
    'player.insp.routeWord.mtb': 'Mountainbike',
    'player.insp.routeWord.bicycle': 'Velo',
    'player.insp.routeName.hiking': 'Wanderroute',
    'player.insp.routeName.foot': 'Fussroute',
    'player.insp.routeName.mtb': 'Mountainbike-Route',
    'player.insp.routeName.bicycle': 'Veloroute',
    'player.insp.route.word': 'Route',
    'player.insp.tag.backrest': 'Rückenlehne',
    'player.insp.tag.covered': 'überdacht',
    'player.insp.tag.drinkingWater': 'Trinkwasser',
    'player.insp.tag.summitCross': 'Gipfelkreuz',
    'player.insp.tag.historic': 'historisch',
    'player.insp.src.bafuLakes': 'BAFU-Seeninventar (VECTOR25)',
    'player.insp.poi.peak': 'Gipfel',
    'player.insp.poi.farpeak': 'Gipfel (ausserhalb der Karte)',
    'player.insp.poi.pass': 'Pass',
    'player.insp.poi.ridge': 'Grat',
    'player.insp.poi.village': 'Dorf',
    'player.insp.poi.town': 'Kleinstadt',
    'player.insp.poi.city': 'Stadt',
    'player.insp.poi.hamlet': 'Weiler',
    'player.insp.poi.suburb': 'Quartier',
    'player.insp.poi.hotel': 'Hotel',
    'player.insp.poi.hostel': 'Hostel',
    'player.insp.poi.restaurant': 'Restaurant',
    'player.insp.poi.cafe': 'Café',
    'player.insp.poi.bar': 'Bar',
    'player.insp.poi.alpineHut': 'Berghütte',
    'player.insp.poi.hut': 'Hütte',
    'player.insp.poi.viewpoint': 'Aussichtspunkt',
    'player.insp.poi.museum': 'Museum',
    'player.insp.poi.gallery': 'Galerie',
    'player.insp.poi.attraction': 'Sehenswürdigkeit',
    'player.insp.poi.church': 'Kirche',
    'player.insp.poi.chapel': 'Kapelle',
    'player.insp.poi.station': 'Lift- / Bahnstation',
    'player.insp.poi.lake': 'See',
    'player.insp.poi.river': 'Fluss',
    'player.insp.poi.hospital': 'Spital',
    'player.insp.obj.fence': 'Zaun',
    'player.insp.obj.guardRail': 'Leitplanke',
    'player.insp.obj.hedge': 'Hecke',
    'player.insp.obj.wall': 'Mauer',
    'player.insp.obj.coping': 'Stützmauer',
    'player.insp.obj.pylon': 'Strommast',
    'player.insp.obj.powerline': 'Stromleitung',
    'player.insp.obj.mast': 'Antennenmast',
    'player.insp.obj.tower': 'Turm',
    'player.insp.obj.chimney': 'Kamin',
    'player.insp.obj.windturbine': 'Windturbine',
    'player.insp.obj.silo': 'Silo',
    'player.insp.obj.utility': 'Versorgungsbaute',
    'player.insp.obj.fountain': 'Brunnen',
    'player.insp.obj.monument': 'Denkmal',
    'player.insp.obj.skijump': 'Sprungschanze',
    'player.insp.obj.waterfall': 'Wasserfall',
    'player.insp.obj.avalanche': 'Lawinen- / Steinschlagverbauung',
    'player.insp.obj.dam': 'Staudamm',
    'player.insp.obj.checkdam': 'Geschiebesperre',
    'player.insp.obj.jetty': 'Steg',
    'player.insp.obj.chute': 'Bobbahn',
    'player.insp.obj.lane': 'Laufbahn',
    'player.insp.obj.court': 'Sportplatz',
    'player.insp.obj.basin': 'Wasserbecken',
    'player.insp.obj.berm': 'Schutzdamm',
    'player.insp.obj.generic': 'Bauwerk',
    'player.insp.fence.chain': 'Maschendraht',
    'player.insp.fence.electric': 'elektrisch',
    'player.insp.fence.wire': 'Draht',
    'player.insp.fence.metal': 'Metallstäbe / Geländer',
    'player.insp.fence.paling': 'Lattenzaun',
    'player.insp.fence.board': 'Bretter / Paneele',
    'player.insp.fence.rail': 'Pfosten und Holm',
    'player.insp.fence.knee': 'niedriges Geländer',
    'player.insp.pylon.tower': 'Gittermast',
    'player.insp.pylon.pole': 'Stangenmast',
    'player.insp.pylon.portal': 'Portal',
    'player.insp.pylon.terminal': 'Endmast',
    'player.insp.art.antenneKlein': 'kleine Antenne (Mobilfunk / Relais)',
    'player.insp.art.antenneGross': 'grosse Antenne',
    'player.insp.art.antenne': 'Antenne',
    'player.insp.art.sendeturm': 'Sendeturm',
    'player.insp.art.aussichtsturm': 'Aussichtsturm',
    'player.insp.art.wasserturm': 'Wasserturm',
    'player.insp.art.kuehlturm': 'Kühlturm',
    'player.insp.art.leuchtturm': 'Leuchtturm',
    'player.insp.art.turm': 'Turm',
    'player.insp.art.kamin': 'Kamin',
    'player.insp.art.windturbine': 'Windturbine',
    'player.insp.art.silo': 'Silo',
    'player.insp.art.wasserversorgung': 'Wasserversorgung',
    'player.insp.art.brunnen': 'Brunnen',
    'player.insp.art.quelle': 'Quelle',
    'player.insp.art.denkmal': 'Denkmal',
    'player.insp.art.bildstock': 'Bildstock',
    'player.insp.art.triangulationspyramide': 'Triangulationspyramide',
    'player.insp.art.wasserfall': 'Wasserfall',
    'player.insp.art.sprungschanze': 'Sprungschanze',
    'player.insp.art.schutzverbauung': 'Lawinen- / Steinschlagschutz',
    'player.insp.art.gewaesserverbauung': 'Gewässerverbauung',
    'player.insp.art.lawinenverbauung': 'Lawinenverbauung',
    'player.insp.art.trockenmauer': 'Trockenmauer',
    'player.insp.art.stuetzmauer': 'Stützmauer',
    'player.insp.art.mauer': 'Mauer',
    'player.insp.art.stromleitung': 'Stromleitung',
    'player.insp.art.scheibenstand': 'Scheibenstand',
    'player.insp.art.hafensteg': 'Hafensteg',
    'player.insp.art.bobbahn': 'Bobbahn',
    'player.insp.art.laufbahn': 'Laufbahn',
    'player.insp.art.staumauer': 'Staumauer',
    'player.insp.art.schutzdamm': 'Schutzdamm',
    'player.insp.art.wehr': 'Wehr',
    'player.insp.art.wasserbecken': 'Wasserbecken',
    'player.insp.art.sportplatz': 'Sportplatz',
    'player.insp.art.hartbelagpiste': 'Hartplatz',
    'player.insp.art.rollfeldHartbelag': 'befestigtes Rollfeld',
    'player.insp.hfrom.tlmPoint': 'vermessene Spitze (swissTLM3D-Punkt − Boden)',
    'player.insp.hfrom.tlmOutline': 'vermessene Oberkante (swissTLM3D-Umriss − Boden)',
    'player.insp.hfrom.tlmLine': 'Vermessungslinie über dem Boden (swissTLM3D, Median)',
    'player.insp.hfrom.osm': 'OpenStreetMap-Höhenangabe',
    'player.insp.hfrom.pole': 'typischer Mast (keine OSM-Höhe)',
    'player.insp.hfrom.rule': 'Regel: Leitplanke auf der Mauerkrone',
    'player.insp.hfrom.defaultTlm': 'typisch für die Klasse — swissTLM3D liefert keine brauchbare Spitze',
    'player.insp.hfrom.defaultOsm': 'typisch für die Klasse — keine OSM-Höhe',
    'player.insp.val.asl': '{h} ü. M.',
    'player.insp.row.type': 'Typ',
    'player.insp.row.tlmClass': 'swissTLM3D-Klasse',
    'player.insp.row.name': 'Name',
    'player.insp.row.fenceType': 'Zauntyp',
    'player.insp.row.material': 'Material',
    'player.insp.row.coping': 'Mauerkrone',
    'player.insp.obj.copingSide': 'auf der höheren Seite der Linie',
    'player.insp.row.voltage': 'Spannung',
    'player.insp.val.notTagged': 'nicht erfasst',
    'player.insp.row.tlmVoltage': 'TLM-Spannungsklasse',
    'player.insp.row.circuits': 'Stromkreise',
    'player.insp.row.supports': 'Masten',
    'player.insp.row.length': 'Länge',
    'player.insp.row.openings': 'Öffnungen',
    'player.insp.row.footprint': 'Grundfläche',
    'player.insp.obj.footprint': '{area} m² · Umriss {outline}',
    'player.insp.row.height': 'Höhe',
    'player.insp.obj.heightTypical': '{h} m (typisch)',
    'player.insp.row.heightFrom': 'Höhe aus',
    'player.insp.obj.surveyAtGround': 'der Vermessungspunkt liegt am Boden',
    'player.insp.obj.implausibleFor': 'unplausibel für {what}',
    'player.insp.obj.anArt': '\'{art}\'',
    'player.insp.obj.itsClass': 'seine Klasse',
    'player.insp.row.surveyTop': 'Vermessene Spitze',
    'player.insp.obj.surveyTop': '{top} ü. M. = {dz} m über dem Boden — verworfen, {why}',
    'player.insp.row.fallCrest': 'Oberkante',
    'player.insp.row.fall': 'Fallhöhe',
    'player.insp.obj.fallTo': '{h} m bis {base}',
    'player.insp.row.base': 'Basis',
    'player.insp.row.top': 'Oberkante',
    'player.insp.row.ground': 'Boden',
    'player.insp.row.source': 'Quelle',
    'player.insp.obj.tlmRelease': 'swissTLM3D (swisstopo) · Ausgabe {rel}',
    'player.insp.row.drawnBy': 'Gezeichnet nach',
    'player.insp.obj.ruleDrawn': 'Regel — eine Leitplanke auf einer Mauerkrone (kein Kartenobjekt)',
    'player.insp.riding': 'Unterwegs',
    'player.insp.title.routeRef': 'Route {ref}',
    'player.insp.trail.walkBoth': '{there} hin · {back} zurück',
    'player.insp.row.official': 'Offiziell',
    'player.insp.trail.extraOfficial': '{mark} (swissTLM3D), nicht in OSM erfasst',
    'player.insp.row.width': 'Breite',
    'player.insp.row.surface': 'Untergrund',
    'player.insp.row.thisSection': 'Dieser Abschnitt',
    'player.insp.row.inGame': 'Im Spiel',
    'player.insp.trail.mapOnly': 'nur Karte — hier kein begehbarer Pfad',
    'player.insp.row.grade': 'Schwierigkeit',
    'player.insp.trail.noGrade': 'keine SAC-Skala erfasst',
    'player.insp.row.officialClass': 'Offizielle Klasse',
    'player.insp.trail.setsMark': '{mark} (swissTLM3D) — bestimmt die Markierung',
    'player.insp.row.viaFerrata': 'Klettersteig',
    'player.insp.trail.huesler': 'K{n} (Hüsler-Skala)',
    'player.insp.row.mtb': 'MTB-Skala',
    'player.insp.row.trackType': 'Wegtyp',
    'player.insp.row.visibility': 'Sichtbarkeit',
    'player.insp.row.incline': 'Steigung',
    'player.insp.trail.uphill': 'bergauf (in Linienrichtung)',
    'player.insp.trail.downhill': 'bergab (in Linienrichtung)',
    'player.insp.row.vehicles': 'Fahrzeuge',
    'player.insp.row.wholePath': 'Ganzer Pfad',
    'player.insp.row.walkingTime': 'Wanderzeit',
    'player.insp.h.onRoutes': 'Auf Routen',
    'player.insp.row.route': 'Route',
    'player.insp.row.network': 'Netz',
    'player.insp.row.fromTo': 'Von → nach',
    'player.insp.row.loop': 'Rundweg',
    'player.insp.route.loopYes': 'ja — endet, wo sie beginnt',
    'player.insp.row.operator': 'Betreiber',
    'player.insp.row.website': '🔗 Website',
    'player.insp.h.insideMap': 'Innerhalb dieser Karte',
    'player.insp.row.stage': 'Etappe',
    'player.insp.route.nOf': '{n} von {total}',
    'player.insp.row.guide': 'Führung',
    'player.insp.route.following': 'folgst Etappe {n} — der goldene Beacon läuft ~{ahead} m voraus',
    'player.insp.route.followingRev': 'folgst Etappe {n} (umgekehrt) — der goldene Beacon läuft ~{ahead} m voraus',
    'player.insp.act.stopGuide': 'Führung stoppen',
    'player.insp.res.guideStopped': 'Führung gestoppt',
    'player.insp.act.reverse': 'Umkehren',
    'player.insp.res.guideReversed': 'Führung in Gegenrichtung',
    'player.insp.act.guideCombat': 'Führ mich (Kampf an)',
    'player.insp.act.guide': 'Führ mich',
    'player.insp.res.guiding': 'Führung entlang {name} — folge dem goldenen Beacon (~{ahead} m voraus)',
    'player.insp.res.theRoute': 'der Route',
    'player.insp.res.stageOf': 'Etappe {n} von {total}',
    'player.insp.act.prevStage': 'Vorige Etappe',
    'player.insp.act.nextStage': 'Nächste Etappe',
    'player.insp.val.yes': 'ja',
    'player.insp.val.no': 'nein',
    'player.insp.row.shop': 'Laden',
    'player.insp.h.shops': 'Läden ({n})',
    'player.insp.val.shop': 'Laden',
    'player.insp.row.stopNumber': 'Haltestellennummer',
    'player.insp.row.shelter': 'Unterstand',
    'player.insp.row.bench': 'Bank',
    'player.insp.row.passHeight': 'Passhöhe',
    'player.insp.row.details': 'Details',
    'player.insp.val.coarse': '{label} (grob)',
    'player.insp.row.tourism': 'Tourismus',
    'player.insp.row.historic': 'Historisch',
    'player.insp.row.office': 'Büro',
    'player.insp.row.address': 'Adresse',
    'player.insp.val.regLoading': 'lade das Register…',
    'player.insp.val.noAddress': 'keine Adresse erfasst',
    'player.insp.row.registerName': 'Name im Register',
    'player.insp.row.buildingClass': 'Gebäudeklasse',
    'player.insp.row.category': 'Kategorie',
    'player.insp.row.built': 'Baujahr',
    'player.insp.val.before': 'vor {y}',
    'player.insp.row.storeys': 'Geschosse',
    'player.insp.row.dwellings': 'Wohnungen',
    'player.insp.row.protected': 'Geschützt',
    'player.insp.val.eavesRidge': '{h} m (Traufe/First)',
    'player.insp.res.pointThere': 'der goldene Beacon + der Kompassstreifen zeigen dorthin',
    'player.insp.row.ridgeCrest': 'Grat',
    'player.insp.row.prominence': 'Schartenhöhe',
    'player.insp.row.trail': 'Pfad',
    'player.insp.val.pathEnds': '{grade} — ein Pfad endet im Umkreis von 150 m',
    'player.insp.val.line': 'Linie',
    'player.insp.row.lines': 'Linien',
    'player.insp.res.notNow': 'jetzt nicht — warte auf die Kabine',
    'player.insp.row.lineLength': 'Linienlänge',
    'player.insp.row.vertical': 'Höhendifferenz',
    'player.insp.water.reservoirNatural': 'Stausee (natürlicher See)',
    'player.insp.water.reservoir': 'Stausee',
    'player.insp.water.naturalLake': 'natürlicher See',
    'player.insp.row.officialName': 'Offizieller Name',
    'player.insp.row.waterLevel': 'Wasserspiegel',
    'player.insp.row.waterTemp': 'Wassertemperatur',
    'player.insp.row.maxDepth': 'Max. Tiefe',
    'player.insp.row.area': 'Fläche',
    'player.insp.row.shore': 'Uferlänge',
    'player.insp.row.elevation': 'Höhenlage',
    'player.insp.row.volume': 'Volumen',
    'player.insp.val.mioM3': '{v} Mio. m³',
    'player.insp.row.usableVolume': 'Nutzvolumen',
    'player.insp.row.regulated': 'Reguliert',
    'player.insp.row.gauge': 'Pegel',
    'player.insp.val.unnamed': 'ohne Namen',
    'player.insp.row.range': 'Distanz',
    'player.insp.val.openSkyLine': 'offener Himmel — keine Oberfläche auf dieser Linie',
    'player.insp.val.measuring': 'messe — Gelände lädt',
    'player.insp.val.noClassMap': 'hier keine Klassenkarte',
    'player.insp.row.slope': 'Neigung',
    'player.insp.row.faces': 'Ausrichtung',
    'player.insp.h.position': 'Position',
    'player.insp.row.game': 'Spiel',
    'player.insp.h.near': 'In der Nähe',
    'player.insp.title.officialPath': 'Offizieller Pfad (swissTLM3D)',
    'player.insp.title.unnamedPath': 'Unbenannter Pfad',
    'player.insp.title.openSky': 'Offener Himmel',
    'player.insp.title.target': 'Ziel',
    'player.insp.src.optic': 'optische Messung',
    'player.insp.src.ray': 'Geländestrahl',
    'player.insp.src.mapTap': 'Kartentipp',
    'player.insp.src.noRange': 'keine Distanz (Himmel)',
    'player.insp.src.osm': '© OpenStreetMap-Mitwirkende',
    'player.insp.src.dem': 'swisstopo DHM',
    'player.insp.src.nearestReg': 'nächster Registereintrag',
    'player.insp.src.sacScale': 'SAC-Wanderskala',
    'player.insp.src.routeRel': 'Routenrelationen',
    'player.insp.src.bafuGauges': 'BAFU-Messnetz Hydrometrie',
    'player.insp.src.classMap': 'Klassenkarte',
    'player.insp.act.beaconOff': 'Beacon aus',
    'player.insp.act.beacon': 'Beacon',
    'player.insp.res.beaconCleared': 'Beacon entfernt',
    'player.insp.res.beaconSet': 'Beacon gesetzt auf {name}',
    'player.insp.act.look': 'Hinschauen',
    'player.insp.act.map': 'Karte',
    'player.insp.res.pinnedWrist': 'auf deiner Handgelenk-Karte markiert',
    'player.insp.res.pinnedMap': 'auf der Karte markiert',
    'player.insp.act.beamOutside': 'Beam (ausserhalb der Karte)',
    'player.insp.act.beamStart': 'Beam — hier in 3D starten',
    'player.insp.act.beamThere': 'Dorthin beamen',
    'player.insp.act.beamCharging': 'beamt…',
    'player.insp.act.beamEsc': 'Esc bricht ab',
    'player.insp.res.refusedOutside': 'abgelehnt — ausserhalb der Karte',
    'player.insp.alsoHere': 'auch hier',
    'player.insp.res.failed': 'das hat nicht geklappt',
    'player.insp.res.beaming': 'beame schon…',
    'player.insp.res.refusedCombat': 'abgelehnt — Kampf ist an',
    'player.insp.res.refusedServer': 'abgelehnt — Kampf an, ausserhalb der Grenzen oder ein anderer Beam innert 2 s',
    'player.insp.res.beamed': '✓ gebeamt — {h} m',
    'player.insp.res.noReply': 'abgelehnt — keine Antwort vom Server',
    // @@DE northlock
    'player.map.lockOn': 'Norden fixiert — mit zwei Fingern drehen · tippen: folgt dem Handy',
    'player.map.lockOff': 'Folgt deinem Handy — tippen: Norden fixieren',
    // @@DE-END
  },
});
